// Przestrzeń nazw 'metrics': teksty wspólne dla wykresów, kafelków i metryk (kafelek KPI, znaczniki
// DANE DEMO, jednostki, nazwy okresów) oraz dla widżetów, które Pulpit dziś ukrywa (metryki
// rozmów i SMS, analizy, wydajność AI). Same ekrany mają własne przestrzenie: dashboard,
// statistics, satisfaction.
export default {
  // Tytuły sekcji ukrytych widżetów. Kod zostaje w repo, więc teksty też.
  // VERIFY: cały blok, brak w mockupie (mockup nie ma tych widżetów).
  sections: {
    smsMetrics: 'Metryki SMS',
    callMetrics: 'Metryki rozmów',
    insights: 'Analizy',
    aiPerformance: 'Wydajność AI',
  },

  // Znaczniki na kartach i kafelkach, których liczb nie zwraca żaden endpoint.
  demoBadge: {
    demo: 'DANE DEMO',
    // VERIFY: brak w mockupie, dwa dodatkowe znaczniki. „not-ported" to liczba, która istnieje
    // gdzie indziej i trzeba ją tylko wystawić; „no-feature" to funkcja, której jeszcze nie ma.
    notPorted: 'NIEPRZENIESIONE',
    noFeature: 'BRAK FUNKCJI',
  },

  kpiTile: {
    // VERIFY: brak w mockupie. Zapasowy podpis, gdy ekran nie poda własnego (Statystyki podają,
    // patrz statistics.deltaCaption).
    deltaCaption: 'vs poprzedni okres',
    // VERIFY: brak w mockupie, tam kierunek niesie tylko strzałka i kolor. To etykieta dla
    // czytnika ekranu.
    deltaLabel: {
      up: 'wzrost o {{value}}',
      down: 'spadek o {{value}}',
      flat: 'bez zmian ({{value}})',
    },
  },

  starRating: {
    none: 'brak',
    // VERIFY: brak w mockupie, etykieta dla czytnika ekranu.
    label: '{{score}} z 5',
  },

  topicsDonut: {
    // VERIFY: mockup podpisuje środek pierścienia „rozmów", ale to liczba oznaczeń tematów
    // (jedna rozmowa może mieć kilka), więc suma bywa większa niż liczba rozmów.
    mentions_one: 'wzmianka',
    mentions_few: 'wzmianki',
    mentions_many: 'wzmianek',
    mentions_other: 'wzmianki',
  },

  // VERIFY: cały blok, brak w mockupie (modal ze szczegółami popularnych tematów).
  trendingTopics: {
    name: 'Nazwa',
    count: 'Liczba',
    percent: 'Procent',
  },

  // Nazwy tematu w cudzysłowie: Polskie „…", nie ASCII.
  quotedTopic: '„{{name}}”',
  rankedTopic: '{{rank}}. „{{name}}”',

  // VERIFY: brak w mockupie. Etykieta zbiorczej pozycji, gdy tematów jest więcej niż kolorów
  // pierścienia; w nawiasie liczba zwiniętych tematów.
  overflow: 'Inne ({{hidden}})',
  other: 'Inne',

  // Jednostki. „{{count, number}}" formatuje liczbę tak samo jak `formatNumber` (Intl, język
  // z i18next), a `count` wybiera formę fleksyjną.
  units: {
    hoursShort: 'godz.',
    minutesShort: 'min',
    // VERIFY: brak w mockupie (tam sekundy nie występują).
    secondsShort: 's',
    calls_one: '{{count, number}} rozmowa',
    calls_few: '{{count, number}} rozmowy',
    calls_many: '{{count, number}} rozmów',
    calls_other: '{{count, number}} rozmowy',
    cases_one: '{{count, number}} sprawa',
    cases_few: '{{count, number}} sprawy',
    cases_many: '{{count, number}} spraw',
    cases_other: '{{count, number}} sprawy',
  },

  // Nazwa okresu w miejscowniku, do zdań typu „Rozmowy w ostatnich 30 dniach". Klucze to presety
  // z `TimeRange` plus `custom` (własny zakres).
  range: {
    in: {
      // VERIFY: mockup ma „w ostatnich 30 dniach" tylko dla 30 dni; pozostałe presety własne.
      '24h': 'w ostatnich 24 godzinach',
      '3d': 'w ostatnich 3 dniach',
      '7d': 'w ostatnich 7 dniach',
      '30d': 'w ostatnich 30 dniach',
      '1y': 'w ostatnim roku',
      custom: 'w wybranym okresie',
    },
  },

  // Ukryte widżety Pulpitu: metryki rozmów i SMS, analizy, wydajność AI.
  // VERIFY: cały blok poniżej, brak w mockupie (mockup nie ma tych widżetów).
  callMetric: {
    legend: {
      // Drugą serię, „AI", zostawia kod jako literał. Urzędnik to człowiek po przekazaniu rozmowy.
      agent: 'Urzędnik',
    },
    noRecords: 'Brak rekordów do wyświetlenia w wybranym zakresie dat ({{from}} – {{to}})',
    header: {
      inbound: 'Przychodzące',
      calls: 'rozmowy:',
      sms: 'SMS-y:',
    },
    cards: {
      answer: {
        title: 'Wskaźnik odebranych rozmów',
        tooltip: 'Odsetek rozmów przychodzących, które zostały odebrane.',
        description_one: 'odebrana rozmowa',
        description_few: 'odebrane rozmowy',
        description_many: 'odebranych rozmów',
        description_other: 'odebranej rozmowy',
      },
      abandon: {
        title: 'Wskaźnik porzuconych rozmów',
        tooltip: 'Odsetek rozmów przychodzących, które rozmówca porzucił przed odebraniem.',
        description_one: 'porzucona rozmowa',
        description_few: 'porzucone rozmowy',
        description_many: 'porzuconych rozmów',
        description_other: 'porzuconej rozmowy',
      },
      aiResolution: {
        title: 'Wskaźnik rozwiązań przez AI',
        tooltip: 'Odsetek rozmów rozwiązanych przez AI bez przekazania do urzędnika.',
        description_one: 'rozmowa rozwiązana przez AI',
        description_few: 'rozmowy rozwiązane przez AI',
        description_many: 'rozmów rozwiązanych przez AI',
        description_other: 'rozmowy rozwiązanej przez AI',
      },
      agentHandoff: {
        title: 'Wskaźnik przekazań do urzędnika',
        tooltip: 'Odsetek rozmów przekazanych z AI do urzędnika.',
        description_one: 'rozmowa przekazana do urzędnika',
        description_few: 'rozmowy przekazane do urzędnika',
        description_many: 'rozmów przekazanych do urzędnika',
        description_other: 'rozmowy przekazanej do urzędnika',
      },
      asa: {
        title: 'Średni czas odpowiedzi (ASA)',
        // Skrót w legendzie wykresu, gdy aktywna jest ta karta.
        shortTitle: 'ASA',
        tooltip: 'Średni czas (w minutach), po którym rozmowę odbiera AI lub urzędnik.',
        description: '(minuty:sekundy)',
      },
    },
  },

  smsMetric: {
    cards: {
      aiResolution: {
        title: 'Wskaźnik rozwiązań przez AI',
        tooltip: 'Odsetek wiadomości SMS rozwiązanych przez AI bez przekazania do urzędnika.',
        description_one: 'SMS rozwiązany przez AI',
        description_few: 'SMS-y rozwiązane przez AI',
        description_many: 'SMS-ów rozwiązanych przez AI',
        description_other: 'SMS-a rozwiązanego przez AI',
      },
      agentHandoff: {
        title: 'Wskaźnik przekazań do urzędnika',
        tooltip: 'Odsetek wiadomości SMS przekazanych z AI do urzędnika.',
        description_one: 'SMS przekazany do urzędnika',
        description_few: 'SMS-y przekazane do urzędnika',
        description_many: 'SMS-ów przekazanych do urzędnika',
        description_other: 'SMS-a przekazanego do urzędnika',
      },
      asa: {
        title: 'Średni czas odpowiedzi (ASA)',
        tooltip: 'Średni czas (w minutach), po którym na wiadomość SMS odpowiada AI lub urzędnik.',
        description: '(minuty:sekundy)',
      },
    },
  },

  aiPerformance: {
    titles: {
      responsesPerCall: 'Średnia liczba odpowiedzi AI na rozmowę',
      handlingTime: 'Średni czas obsługi przez AI',
      responseTime: 'Średni czas odpowiedzi',
    },
    tooltips: {
      responsesPerCall:
        'Średnia liczba odpowiedzi udzielonych przez AI w jednej rozmowie. Pokazuje, jak interaktywne i responsywne jest AI.',
      handlingTime:
        'Średni czas, jaki AI poświęca na obsługę rozmowy. Pokazuje, jak sprawnie AI załatwia zapytania.',
      responseTime:
        'Średni czas, po którym AI odpowiada na zapytanie. Pokazuje szybkość odpowiedzi AI.',
    },
  },

  insights: {
    titles: {
      trendingTopics: 'Popularne tematy',
      languageDistribution: 'Języki rozmów',
      averageSatisfaction: 'Średnia ocena satysfakcji (CSAT)',
    },
    csat: {
      overallSatisfaction: 'Ogólna satysfakcja',
      responses_one: '({{count, number}} ocena)',
      responses_few: '({{count, number}} oceny)',
      responses_many: '({{count, number}} ocen)',
      responses_other: '({{count, number}} oceny)',
    },
    tooltips: {
      trendingTopics:
        'Najczęstsze tematy zapytań obsługiwanych przez VoiceSphere. Pokazują, czego dotyczą sprawy mieszkańców i jak zmieniają się trendy.',
      languageDistribution:
        'Wykres kołowy pokazuje rozkład języków rozmów, czyli w jakich językach mieszkańcy dzwonią najczęściej.',
      csatScore:
        'Wskaźnik satysfakcji (CSAT) odzwierciedla ogólne zadowolenie mieszkańców z obsługi przez AI i urzędników. Wyższy wynik oznacza lepszą obsługę.',
    },
    detailsTitle: 'Szczegóły popularnych tematów',
    downloaded: 'Plik został pobrany',
    downloadFailed: 'Nie udało się pobrać popularnych tematów',
  },
} as const;
